import { CurrencyAmount, Token } from '@kodiak-finance/sdk-core'
import { WrappedTokenInfo } from 'state/lists/wrappedTokenInfo'

export const filterNonZeroTokensBalances = (
  tokens: WrappedTokenInfo[],
  balances: (CurrencyAmount<Token> | undefined)[]
): WrappedTokenInfo[] => {
  if (!tokens || !balances) return []

  const nonZeroBalances = balances.filter((balance) => balance && balance.greaterThan(0))
  const nonZeroBalancesAddresses = nonZeroBalances.map((balance) => balance?.currency.address)
  const tokensWithNonZeroBalances = tokens.filter((token) => nonZeroBalancesAddresses.includes(token.address))

  return tokensWithNonZeroBalances
}
